import Repository from '@/repositories/repository'

const HantecSocialRepository = {
  async getHantecSocialData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('hantec-social-copy-trading', 'page', params)
  }
}

export default HantecSocialRepository
